import React from 'react';
import styles from './supporting-cluster-info.scss';

const SupportingClusterInfo = () => {
  return (
    <div className={styles.infoBox}>
      <img
        src={`${process.env.PUBLIC_URL}/img/icon-info.svg`}
        alt="info icon"
      />
      <p className={styles.infoBoxText}>
        Agencies within these connected clusters are supporting this project.
      </p>
    </div>
  );
};

export default SupportingClusterInfo;



// WEBPACK FOOTER //
// ./src/components/supporting-cluster-info/supporting-cluster-info.js